import React, { createContext, useContext, useState } from 'react';

type EditorSidebarContextType = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  toggleSidebar: () => void;
};

const EditorSidebarContext = createContext<EditorSidebarContextType | undefined>(undefined);

type EditorSidebarProviderProps = {
  children: React.ReactNode;
  initialOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
};

export const EditorSidebarProvider = ({
  children,
  initialOpen = false,
  onToggle,
}: EditorSidebarProviderProps) => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  const toggleSidebar = () => {
    const newState = !isOpen;
    setIsOpen(newState);
    onToggle?.(newState);
  };

  const handleSetIsOpen = (newIsOpen: boolean) => {
    setIsOpen(newIsOpen);
    onToggle?.(newIsOpen);
  };

  const value = {
    isOpen,
    setIsOpen: handleSetIsOpen,
    toggleSidebar,
  };

  return <EditorSidebarContext.Provider value={value}>{children}</EditorSidebarContext.Provider>;
};

export const useEditorSidebar = () => {
  const context = useContext(EditorSidebarContext);
  if (context === undefined) {
    throw new Error('useEditorSidebar must be used within a EditorSidebarProvider');
  }
  return context;
};
